<div id="message-container" class="full-height layout-row" [ngClass]="{'current-user': currentUser?.identity === user?.identity}">
  <div id="message" class="flex layout-row gap-10">

    <div class="layout-column">
      <chat-user-avatar *ngIf="!!user?.attributes"
                        [url]="user.attributes['avatarUrl']"
                        [name]="user.attributes['fullName']"
                        [color]="color"></chat-user-avatar>
    </div>
    <div class="flex layout-column gap-5">
      <div class="layout-row layout-align-start-center gap-10 color-gray-800">
        <span *ngIf="!!user?.attributes" class="br-body-2 font-weight-600">{{user.attributes['fullName']}}</span>
<!--        <span *ngIf="!!user?.attributes" class="br-body-2 font-weight-400">{{user.attributes.type}}</span>-->
        <span class="br-body-2 opacity-60">{{message.dateCreated | chatConversationTimePipe}}</span>
      </div>
      <img *ngIf="mediaContentType?.includes('image')" id="chat-message-image" [src]="mediaUrl" (click)="onViewImage($event, mediaUrl)">
      <!--    <source *ngIf="mediaContentType?.includes('audio')" [src]="mediaUrl" [type]="mediaContentType">-->

      <p class="br-body-2 margin-0 body">{{message.body}}</p>
    </div>
    <!--  <div class="timer">{{conversation.dateUpdated | date:'shortTime'}}</div>-->
  </div>
</div>
